import type { AuthUser } from "@spiriidk/auth";
import {
  DEFAULT_LOCALE,
  FEATURE_FLAGS,
  type Locale,
} from "@spiriidk/connect-configs";
import { getFlag } from "@spiriidk/feature-flags";
import _refiner from "refiner-js";

const REFINER_PROJECT_ID = import.meta.env.VITE_REFINER_PROJECT_ID as
  string | undefined;
const IS_LOCAL = import.meta.env.VITE_LOCAL === "true";

function toRefinerLocales(locale: Locale): string {
  return locale === DEFAULT_LOCALE ? locale : `${locale},${DEFAULT_LOCALE}`;
}

function initializeRefiner(authData: AuthUser, locale: Locale): void {
  if (!REFINER_PROJECT_ID || IS_LOCAL) {
    return;
  }

  void _refiner("setProject", REFINER_PROJECT_ID);
  void _refiner("setLocale", toRefinerLocales(locale));
  void _refiner("identifyUser", {
    id: authData.userId,
    login: authData.login,
    email: authData.email,
    name: authData.name,
    role: authData.userPermissions[0],
    operatorId: authData.permittedOperatorId,
    companyId: authData.permittedCompanyId,
    release_connect_settings: String(getFlag(FEATURE_FLAGS.SETTINGS)),
  });
}

export { initializeRefiner };
